import styled from "styled-components";

const Name = styled.span`
    background: white;
    color: black;
    padding: 8px;
    border-radius: 10px;
`;
export default Name;
